export const leadType =[
  'Show Room', 
  'Trimmed', 
  'Self Gen', 
  'Renewal', 
 'Phone Sales', 
 'OnIt Home',
 'Authorized Partner Security']